import {FeatureName, FeatureEnablement} from './types'

export const TERMS_OF_SERVICE_URL =
  'https://legal.campminder.com/terms-of-service/'

export const PRIVACY_POLICY_URL = 'https://legal.campminder.com/privacy-policy/'

export const SYSTEM_URL = 'https://system.campminder.com/v2/login/login.aspx'

export const AIRBRIDGE_TRACKING_LINKS_URL =
  'https://api.airbridge.io/v1/tracking-links'

export const UPR_URL = 'https://system.campminder.com/ui/person/Record#'

export const EZT_URL = 'https://app.campmindertexting.com'
export const EZT_GROUP_URL = `${EZT_URL}/contacts/index/group/`

export const MAX_CONTENT_CHARS = 280

export const MAX_HYPERLINK_TEXT_CHARS = 26

export const AUTH_SESSION_STORAGE_KEY = '__authsession__'

export const ROTATE_PHOTO_DEBOUNCE_TIMEOUT = 7000

export const FEATURE_ENABLEMENT_MAP: {[k in FeatureName]: FeatureEnablement} = {
  'manage-microposts': {
    isUnderReleaseFlag: false,
  },
  'segment-microposts': {
    isUnderReleaseFlag: false,
  },
  'view-photo-uploader': {
    isUnderReleaseFlag: false,
  },
  'create-album': {
    isUnderReleaseFlag: false,
  },
  'upload-photos': {
    isUnderReleaseFlag: false,
  },
  'photo-action': {
    isUnderReleaseFlag: false,
  },
  'edit-album': {
    isUnderReleaseFlag: false,
  },
  integrations: {
    isUnderReleaseFlag: false,
  },
  'texting-audience': {
    isUnderReleaseFlag: true,
  },
  'texting-enabled': {
    isUnderReleaseFlag: true,
  },
  'data-insights': {
    isUnderReleaseFlag: true,
  },
  'forms-reminder': {
    isUnderReleaseFlag: true,
  },
  'covid-health-check': {
    isUnderReleaseFlag: true,
  },
  'eng-only-server-sent-events': {
    isUnderReleaseFlag: false,
  },
  'eng-only-individual-sync': {
    isUnderReleaseFlag: false,
  },
  'admin-photo-sort': {
    isUnderReleaseFlag: false,
  },
  'admin-menu-registration': {
    isUnderReleaseFlag: true,
  },
  'enable-campanion-staff-engagement-features': {
    isUnderReleaseFlag: true,
  },
}

export const INSERT_PLACEHOLDER_ID = '0' // Use as temporary IDs to allow for upsert functionality while still using base model without optional/null checks

export const SEND_TEXT_BATCH_SIZE = 200

export const MAX_SMS_CHARACTERS = 160

export const LEGACY_ALBUM_CUTOFF_DATE = new Date('2021-11-01')

export const AUTH_CLIENTID_SESSION_STORAGE_KEY = '__current_auth_client__'

// Where the user was headed before the Auth0 redirect took the page away, so
// login verification can return them there instead of dropping them on /albums
// (AB#25795). sessionStorage rather than localStorage: this is meaningful only
// across a single login round trip in a single tab.
export const RETURN_PATH_SESSION_STORAGE_KEY = '__post_login_return_path__'

// Build-time configuration lives in config.ts. Re-exported here so existing
// imports from constants keep working.
export {
  API_URL,
  API_SSE_URL,
  FILESTACK_MP_API_KEY,
  FILESTACK_UP_API_KEY,
  BUGSNAG_API_KEY,
  BUGSNAG_STAGE,
  APP_VERSION,
  GTM_PREVIEW,
  GTM_AUTH,
  CONFIGCAT_CE_FLAGS_SDK_KEY,
  AUTH0_DOMAIN,
  AUTH0_CLIENT_ID,
  AIRBRIDGE_CHANNEL,
  AIRBRIDGE_API_KEY,
  AIRBRIDGE_URL_SCHEME,
} from './config'
